if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      get quantity() {
        return this.querySelector('quantity-input');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get select() {
        return this.querySelector('select');
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }
      get selectSizeText() {
        return this.dataset.selectSizeText || 'Select size';
      }

      get requireSizeSelection() {
        return this.dataset.requireSizeSelection === 'true';
      }

     connectedCallback() {
  this.productFormActions = document.querySelector('.main-product-form');
  this.mainProductInfo = document.querySelector('product-info');
  this.container = this.closest('.sticky-atc-bar');

  this.variantData = this.getVariantData();

  this.init();
  this.updateStickySizeLabels();
  this.observeSizeSystem();

  document.addEventListener('change', (event) => {
    const radio = event.target.closest('.product_variant_option_inner input[type="radio"][data-variant-id]');
    if (!radio || !radio.checked || !this.select) return;

    const variantId = radio.dataset.variantId;
    if (!variantId) return;

    this.select.value = variantId;
    this.select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  this.select.addEventListener('change', () => {
    const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;

    if (!selectedVariantId) {
      this.currentVariant = null;
      this.updateButton(true, this.selectSizeText);
      return;
    }

    this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
    if (!this.currentVariant) {
      this.updateButton(true, this.selectSizeText);
      return;
    }

    this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
    let syncedWithMainForm = false;

    if (this.mainVariantSelects) {
      let changeTarget = null;

      Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset')).forEach((element, index) => {
        const variantOptionVal = this.currentVariant.options[index];

        switch (element.tagName) {
          case 'SELECT':
            element.value = variantOptionVal;
            changeTarget = element;
            break;

          case 'FIELDSET': {
            const matchedRadio = Array.from(element.querySelectorAll('input')).find(
              (radio) => radio.value === variantOptionVal
            );

            if (matchedRadio) {
              matchedRadio.checked = true;
              changeTarget = matchedRadio;
            }
            break;
          }
        }
      });

      if (changeTarget) {
        syncedWithMainForm = true;
        changeTarget.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    this.updatePrice();
    this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);

    if (!syncedWithMainForm) {
      this.updateQuantityInput();
    }
  });
}
updateStickySizeLabels() {
  if (!this.select) return;

  const system = (document.documentElement.getAttribute('data-size-system') || 'EU').toUpperCase();
  const keyMap = {
    EU: 'sizeEu',
    UK: 'sizeUk',
    US: 'sizeUs',
  };
  const key = keyMap[system] || 'sizeEu';

  Array.from(this.select.options).forEach((option) => {
    if (!option.value) return;
    const label = option.dataset[key] || option.dataset.sizeEu || option.textContent;
    option.textContent = label;
  });
}

observeSizeSystem() {
  const root = document.documentElement;
  this.sizeSystemObserver = new MutationObserver(() => {
    this.updateStickySizeLabels();
  });

  this.sizeSystemObserver.observe(root, {
    attributes: true,
    attributeFilter: ['data-size-system'],
  });
}

     updateQuantityInput() {
  if (!this.currentVariant) return;

  const quantityWrapper = this.querySelector(`#QuantitySticky-${this.sectionId}`);
  const currentQtyInput = quantityWrapper && quantityWrapper.querySelector('input[name="quantity"]');
  if (!quantityWrapper || !currentQtyInput) return;

  const previousQty = parseInt(currentQtyInput.value, 10) || 1;

  fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
    .then((response) => response.text())
    .then((responseText) => {
      const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const updatedQtyInput = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId} input[name="quantity"]`);
      if (!updatedQtyInput) return;

      [
        'data-cart-quantity',
        'data-min',
        'data-max',
        'data-quantity-variant-id',
        'step',
        'min',
        'max',
      ].forEach((attribute) => {
        const value = updatedQtyInput.getAttribute(attribute);
        if (value !== null) {
          currentQtyInput.setAttribute(attribute, value);
        } else {
          currentQtyInput.removeAttribute(attribute);
        }
      });

      const min = parseInt(currentQtyInput.getAttribute('data-min') || currentQtyInput.min || '1', 10);
      const maxAttr = currentQtyInput.getAttribute('data-max') || currentQtyInput.max;
      const max = maxAttr ? parseInt(maxAttr, 10) : null;

      let nextValue = Math.max(previousQty, min);
      if (max !== null) {
        nextValue = Math.min(nextValue, max);
      }

      currentQtyInput.value = nextValue;
      currentQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    })
    .catch((error) => {
      console.error(error);
    });
}

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.productForm;
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

     syncWithMainProductForm() {
        const syncStickyFromVariant = (variant) => {
          if (!this.select) return;

          if (!variant) {
            if (this.requireSizeSelection) {
              this.select.value = '';
              this.updateButton(true, this.selectSizeText);
            }
            return;
          }

          this.currentVariant = variant;
          const variantId = String(variant.id);

          Array.from(this.select.options).forEach((option) => {
            option.selected = option.value === variantId;
          });
          this.select.value = variantId;

          this.updateStickySizeLabels();
          this.updatePrice();
          this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          this.updateQuantityInput();
        };

          document.addEventListener('variant:changed', (event) => {
            const variant = event.detail?.variant;
            syncStickyFromVariant(variant);
          });

          FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event?.data?.variant;
            syncStickyFromVariant(variant);
          });
        }
    }
  );
}
